import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { HStack, Heading, Icon, IconButton } from '@chakra-ui/react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
export default function GiveawayModalHeader(param) {
    var title = param.title, onClose = param.onClose;
    var intl = useIntl();
    return /*#__PURE__*/ _jsxs(HStack, {
        justifyContent: "space-between",
        alignItems: "center",
        px: 6,
        py: 4,
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                size: "md",
                children: title
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                variant: "ghost",
                size: "sm",
                "aria-label": intl.formatMessage({
                    id: "rbrahO",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Close"
                        }
                    ]
                }),
                icon: /*#__PURE__*/ _jsx(Icon, {
                    as: FontAwesomeIcon,
                    icon: faClose
                }),
                onClick: onClose
            })
        ]
    });
}
